<template>
  <figure class="w-full m-0">
    <svg id="Layer_1" ref="svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 410 216">
      <defs>
      </defs>
      <rect class="field-bg" x=".6" y="1" width="409" height="214" style="stroke-width: 0;"/>
      <g>
        <g>
          <rect class="field-bg" x=".5" width="409" height="214" style="stroke-width: 0;"/>
          <path class="field-lines" d="M409.5,214H.5V0h409v214ZM2.5,212h405V2H2.5v210Z" style="stroke-width: 0;"/>
        </g>
        <rect class="field-lines" x="109" y="29.7" width="2" height="155" style="stroke-width: 0;"/>
        <rect class="field-lines" x="204" y=".3" width="2" height="214" style="stroke-width: 0;"/>
        <g>
          <rect class="field-lines" x="109" y=".3" width="2" height="2" style="stroke-width: 0;"/>
          <path class="field-lines" d="M111,24.6h-2v-3.7h2v3.7ZM111,17.2h-2v-3.7h2v3.7ZM111,9.8h-2v-3.8h2v3.8Z" style="stroke-width: 0;"/>
          <rect class="field-lines" x="109" y="28.3" width="2" height="2" style="stroke-width: 0;"/>
        </g>
        <g>
          <rect class="field-lines" x="109" y="184.3" width="2" height="2" style="stroke-width: 0;"/>
          <path class="field-lines" d="M111,208.6h-2v-3.7h2v3.7ZM111,201.2h-2v-3.7h2v3.7ZM111,193.8h-2v-3.8h2v3.8Z" style="stroke-width: 0;"/>
          <rect class="field-lines" x="109" y="212.3" width="2" height="2" style="stroke-width: 0;"/>
        </g>
        <g>
          <rect class="field-lines" x="299" y=".3" width="2" height="2" style="stroke-width: 0;"/>
          <path class="field-lines" d="M301,24.6h-2v-3.7h2v3.7ZM301,17.2h-2v-3.7h2v3.7ZM301,9.8h-2v-3.8h2v3.8Z" style="stroke-width: 0;"/>
          <rect class="field-lines" x="299" y="28.3" width="2" height="2" style="stroke-width: 0;"/>
        </g>
        <g>
          <rect class="field-lines" x="299" y="184.3" width="2" height="2" style="stroke-width: 0;"/>
          <path class="field-lines" d="M301,208.6h-2v-3.7h2v3.7ZM301,201.2h-2v-3.7h2v3.7ZM301,193.8h-2v-3.8h2v3.8Z" style="stroke-width: 0;"/>
          <rect class="field-lines" x="299" y="212.3" width="2" height="2" style="stroke-width: 0;"/>
        </g>
        <g>
          <rect class="field-lines" x="108" y="29.7" width="2" height="2" style="stroke-width: 0;"/>
          <path class="field-lines" d="M104.1,31.7h-3.9v-2h3.9v2ZM96.2,31.7h-3.9v-2h3.9v2ZM88.4,31.7h-3.9v-2h3.9v2ZM80.5,31.7h-3.9v-2h3.9v2ZM72.7,31.7h-3.9v-2h3.9v2ZM64.8,31.7h-3.9v-2h3.9v2ZM57,31.7h-4v-2h4v2ZM49.1,31.7h-3.9v-2h3.9v2ZM41.3,31.7h-3.9v-2h3.9v2ZM33.4,31.7h-3.9v-2h3.9v2ZM25.6,31.7h-3.9v-2h3.9v2ZM17.7,31.7h-3.9v-2h3.9v2ZM9.9,31.7h-3.9v-2h3.9v2Z" style="stroke-width: 0;"/>
          <rect class="field-lines" y="29.7" width="2" height="2" style="stroke-width: 0;"/>
        </g>
        <g>
          <rect class="field-lines" x="108" y="182.7" width="2" height="2" style="stroke-width: 0;"/>
          <path class="field-lines" d="M104.1,184.7h-3.9v-2h3.9v2ZM96.2,184.7h-3.9v-2h3.9v2ZM88.4,184.7h-3.9v-2h3.9v2ZM80.5,184.7h-3.9v-2h3.9v2ZM72.7,184.7h-3.9v-2h3.9v2ZM64.8,184.7h-3.9v-2h3.9v2ZM57,184.7h-4v-2h4v2ZM49.1,184.7h-3.9v-2h3.9v2ZM41.3,184.7h-3.9v-2h3.9v2ZM33.4,184.7h-3.9v-2h3.9v2ZM25.6,184.7h-3.9v-2h3.9v2ZM17.7,184.7h-3.9v-2h3.9v2ZM9.9,184.7h-3.9v-2h3.9v2Z" style="stroke-width: 0;"/>
          <rect class="field-lines" y="182.7" width="2" height="2" style="stroke-width: 0;"/>
        </g>
        <rect class="field-lines" x="299" y="29.3" width="2" height="155" style="stroke-width: 0;"/>
        <g>
          <rect class="field-lines" x="300" y="182.3" width="2" height="2" style="stroke-width: 0;"/>
          <path class="field-lines" d="M404.1,184.3h-3.9v-2h3.9v2ZM396.2,184.3h-3.9v-2h3.9v2ZM388.4,184.3h-3.9v-2h3.9v2ZM380.5,184.3h-3.9v-2h3.9v2ZM372.7,184.3h-3.9v-2h3.9v2ZM364.8,184.3h-3.9v-2h3.9v2ZM357,184.3h-4v-2h4v2ZM349.1,184.3h-3.9v-2h3.9v2ZM341.3,184.3h-3.9v-2h3.9v2ZM333.4,184.3h-3.9v-2h3.9v2ZM325.6,184.3h-3.9v-2h3.9v2ZM317.7,184.3h-3.9v-2h3.9v2ZM309.8,184.3h-3.9v-2h3.9v2Z" style="stroke-width: 0;"/>
          <rect class="field-lines" x="408" y="182.3" width="2" height="2" style="stroke-width: 0;"/>
        </g>
        <g>
          <rect class="field-lines" x="300" y="29.3" width="2" height="2" style="stroke-width: 0;"/>
          <path class="field-lines" d="M404.1,31.3h-3.9v-2h3.9v2ZM396.2,31.3h-3.9v-2h3.9v2ZM388.4,31.3h-3.9v-2h3.9v2ZM380.5,31.3h-3.9v-2h3.9v2ZM372.7,31.3h-3.9v-2h3.9v2ZM364.8,31.3h-3.9v-2h3.9v2ZM357,31.3h-4v-2h4v2ZM349.1,31.3h-3.9v-2h3.9v2ZM341.3,31.3h-3.9v-2h3.9v2ZM333.4,31.3h-3.9v-2h3.9v2ZM325.6,31.3h-3.9v-2h3.9v2ZM317.7,31.3h-3.9v-2h3.9v2ZM309.8,31.3h-3.9v-2h3.9v2Z" style="stroke-width: 0;"/>
          <rect class="field-lines" x="408" y="29.3" width="2" height="2" style="stroke-width: 0;"/>
        </g>
        <rect class="field-lines" x="189.5" y="29.3" width="31" height="2" style="stroke-width: 0;"/>
        <rect class="field-lines" x="204.3" y="97.4" width="2" height="19.7" transform="translate(-15.7 176.6) rotate(-45)" style="stroke-width: 0;"/>
        <rect class="field-lines" x="189.3" y="182.3" width="31" height="2" style="stroke-width: 0;"/>
        <rect class="field-lines" x="195.4" y="106.3" width="19.7" height="2" transform="translate(-15.7 176.6) rotate(-45)" style="stroke-width: 0;"/>
        <path class="field-lines" d="M58.3,128.2c-11.6,0-21-9.4-21-21s9.4-21,21-21,21,9.4,21,21-9.4,21-21,21h0ZM58.3,88.2c-10.5,0-19,8.5-19,19s8.5,19,19,19,19-8.5,19-19h0c0-10.5-8.5-19-19-19Z" style="stroke-width: 0;"/>
        <path class="field-lines" d="M62.3,117.3l-17.7-10.2,17.7-10.2v20.3ZM48.7,107.2l11.7,6.7v-13.4l-11.7,6.7Z" style="stroke-width: 0;"/>
        <path class="field-lines" d="M357.3,128.2c-11.6,0-21-9.4-21-21s9.4-21,21-21,21,9.4,21,21-9.4,21-21,21h0ZM357.3,88.2c-10.5,0-19,8.5-19,19s8.5,19,19,19,19-8.5,19-19h0c0-10.5-8.5-19-19-19Z" style="stroke-width: 0;"/>
        <path class="field-lines" d="M353.3,117.3v-20.3l17.7,10.2-17.7,10.2ZM355.3,100.4v13.4l11.7-6.7-11.7-6.7Z" style="stroke-width: 0;"/>
      </g>
      <g>
        <g class="player-position goalie">
          <g class="position">
            <circle class="position" cx="360" cy="108" r="7.5" style="stroke-width: 0;"/>
            <path
                class="position"
                d="M360.1,89.1c-1.6,0-2.6,1.2-2.6,3.3s1,3.3,2.6,3.3,2.3-.8,2.3-2.1h-2.2v-1.6h4.3v1.3c0,2.7-1.8,4.3-4.4,4.3s-4.8-2-4.8-5.2,2.1-5.2,4.8-5.2,4.1,1.4,4.4,3.4h-2.2c-.3-.9-1.1-1.5-2.2-1.5Z" style="stroke-width: 0;"
            />
          </g>
        </g>
        <g class="player-position defense">
          <g class="position">
            <circle class="position" cx="300.1" cy="43" r="7.5" style="stroke-width: 0;"/>
            <path
                class="position"
                d="M297,33.1v-10.1h3.6c3.1,0,5,1.9,5,5.1s-1.9,5.1-5,5.1h-3.6ZM300.5,31.3c1.9,0,2.9-1,2.9-3.3s-1-3.2-2.9-3.2h-1.4v6.5h1.4Z" style="stroke-width: 0;"
            />
          </g>
          <g>
            <circle class="position" cx="300.1" cy="108" r="7.5" style="stroke-width: 0;"/>
            <path class="position" d="M297,97.1v-10.1h3.6c3.1,0,5,1.9,5,5.1s-1.9,5.1-5,5.1h-3.6ZM300.5,95.3c1.9,0,2.9-1,2.9-3.3s-1-3.2-2.9-3.2h-1.4v6.5h1.4Z" style="stroke-width: 0;"/>
          </g>
          <g class="player-position defense">
            <g class="position">
              <circle class="position" cx="300.1" cy="173" r="7.5" style="stroke-width: 0;"/>
              <path
                  class="position"
                  d="M297,163.1v-10.1h3.6c3.1,0,5,1.9,5,5.1s-1.9,5.1-5,5.1h-3.6ZM300.5,161.3c1.9,0,2.9-1,2.9-3.3s-1-3.2-2.9-3.2h-1.4v6.5h1.4Z" style="stroke-width: 0;"
              />
            </g>
          </g>
        </g>
        <g class="player-position midfield">
          <g class="position">
            <circle class="position" cx="205.5" cy="43" r="7.5" style="stroke-width: 0;"/>
            <path
                class="position"
                d="M202.6,23l2.8,6.8h.1l2.8-6.8h2.7v10.2h-2.1v-6.6h-.1l-2.6,6.6h-1.4l-2.6-6.6h-.1v6.7h-2.1v-10.3h2.6Z" style="stroke-width: 0;"
            />
          </g>
        </g>
        <g class="player-position face-off-specialist">
          <circle class="position" cx="205.5" cy="107" r="7.5" style="stroke-width: 0;"/>
          <path
              class="position"
              d="M198.5,88h6.7v1.8h-4.6v2.4h4.1v1.8h-4.1v4.2h-2.2v-10.2h.1Z" style="stroke-width: 0;"
          />
          <path
              class="position"
              d="M211.2,98.3c-2.7,0-4.8-1.9-4.8-5.2s2.1-5.2,4.8-5.2,4.8,1.9,4.8,5.2-2.1,5.2-4.8,5.2ZM211.2,89.7c-1.6,0-2.6,1.2-2.6,3.3s1,3.3,2.6,3.3,2.6-1.2,2.6-3.3-1-3.3-2.6-3.3Z" style="stroke-width: 0;"
          />
        </g>
        <g class="player-position long-stick-midfield ssdm">
            <circle class="position" cx="205.5" cy="173" r="7.5" style="stroke-width: 0;"/>
            <path class="position" d="M167.2,153h2.2v8.4h4.4v1.8h-6.5v-10.2h-.1,0Z" style="stroke-width: 0;"/>
            <path class="position" d="M178.9,154.6c-1.1,0-1.6.5-1.6,1.1s.7,1.1,1.6,1.3l.9.2c1.8.4,3,1.3,3.1,3,0,1.9-1.5,3.1-4,3.1s-4-1.1-4.1-3.3h2.1c.1,1,.9,1.5,2,1.5s1.8-.5,1.8-1.3-.6-1-1.7-1.3l-1.1-.3c-1.7-.4-2.8-1.3-2.8-2.8s1.6-3.1,3.9-3.1,3.8,1.3,3.8,3.1h-2.1c0-.7-.8-1.2-1.8-1.2h0Z" style="stroke-width: 0;"/>
            <path class="position" d="M186.9,153l2.8,6.8h.1l2.8-6.8h2.7v10.2h-2.1v-6.6h-.1l-2.6,6.6h-1.4l-2.6-6.6h-.1v6.7h-2.1v-10.3h2.6Z" style="stroke-width: 0;"/>
            <path class="position" d="M199.3,164.3h-1.9l3.3-12.4h1.9l-3.3,12.4Z" style="stroke-width: 0;"/>
            <path class="position" d="M235.4,153l2.8,6.8h.1l2.8-6.8h2.7v10.2h-2.1v-6.6h-.1l-2.6,6.6h-1.4l-2.6-6.6h-.1v6.7h-2.1v-10.3h2.6Z" style="stroke-width: 0;"/>
            <path class="position" d="M222.8,163v-10.1h3.6c3.1,0,5,1.9,5,5.1s-1.9,5.1-5,5.1h-3.6ZM226.3,161.2c1.9,0,2.9-1,2.9-3.3s-1-3.2-2.9-3.2h-1.4v6.5h1.4Z" style="stroke-width: 0;"/>
            <path class="position" d="M217.2,154.6c-1.1,0-1.6.5-1.6,1.1s.7,1.1,1.6,1.3l.9.2c1.8.4,3,1.3,3.1,3,0,1.9-1.5,3.1-4,3.1s-4-1.1-4.1-3.3h2.1c.1,1,.9,1.5,2,1.5s1.8-.5,1.8-1.3-.6-1-1.7-1.3l-1.1-.3c-1.7-.4-2.8-1.3-2.8-2.8s1.6-3.1,3.9-3.1,3.8,1.3,3.8,3.1h-2.1c0-.7-.8-1.2-1.8-1.2h0Z" style="stroke-width: 0;"/>
            <path class="position" d="M207.9,154.6c-1.1,0-1.6.5-1.6,1.1s.7,1.1,1.6,1.3l.9.2c1.8.4,3,1.3,3.1,3,0,1.9-1.5,3.1-4,3.1s-4-1.1-4.1-3.3h2.1c.1,1,.9,1.5,2,1.5s1.8-.5,1.8-1.3-.6-1-1.7-1.3l-1.1-.3c-1.7-.4-2.8-1.3-2.8-2.8s1.6-3.1,3.9-3.1,3.8,1.3,3.8,3.1h-2.1c0-.7-.8-1.2-1.8-1.2h0Z" style="stroke-width: 0;"/>
        </g>
        <g class="player-position attack">
          <g class="position">
            <circle class="position" cx="110.1" cy="43" r="7.5" style="stroke-width: 0;"/>
            <path
                class="position"
                d="M105,33.1l3.5-10.2h2.8l3.5,10.2h-2.3l-.8-2.3h-3.6l-.8,2.3h-2.3ZM111.2,29.1l-1.3-3.9h0l-1.3,3.9h2.7Z" style="stroke-width: 0;"
            />
          </g>
          <g>
            <circle class="position" cx="110.1" cy="108" r="7.5" style="stroke-width: 0;"/>
            <path
                class="position"
                d="M105,98.1l3.5-10.2h2.8l3.5,10.2h-2.3l-.8-2.3h-3.6l-.8,2.3h-2.3ZM111.2,94.1l-1.3-3.9h0l-1.3,3.9h2.7Z" style="stroke-width: 0;"
            />
          </g>
          <g class="position">
            <circle class="position" cx="110.1" cy="173" r="7.5" style="stroke-width: 0;"/>
            <path
                class="position"
                d="M105,163.1l3.5-10.2h2.8l3.5,10.2h-2.3l-.8-2.3h-3.6l-.8,2.3h-2.3ZM111.2,159.1l-1.3-3.9h0l-1.3,3.9h2.7Z" style="stroke-width: 0;"
            />
          </g>
        </g>
      </g>
    </svg>
  </figure>
</template>

<script>
import positionsLogic from "./AthletePositionsLogic";
export default {
  mixins: [positionsLogic],
};
</script>

<style scoped>
</style>